import { RequestParams, sendRequest } from '.';
import { IAccount, IAccountEfectiveBalance, IGenesysAccountResponse } from '../types/account';

export const getAccountApi = (requestParams: RequestParams) =>
  sendRequest<IAccount>({
    requestType: 'getAccount',
    ...requestParams,
  });

export const getAccountWithEffectiveBalanceApi = (requestParams: RequestParams) =>
  sendRequest<IAccountEfectiveBalance>({
    requestType: 'getAccount',
    includeEffectiveBalance: true,
    ...requestParams,
  });

export const getFoundationWalletsApi = () => {
  const accounts = [
    'APL-HWEH-RRST-6VPP-9SWKX',
    'APL-YPYP-UE8N-2LPJ-BJWJD',
    'APL-ELYW-KWRX-X457-82JD7',
    'APL-2S35-2LDG-8WJQ-G8AL8',
  ].map((account) => getAccountApi({ account }));

  return Promise.all(accounts);
};

export const getGenesisBalanceInfoApi = (params: RequestParams) => {
  const requestParams = {
    ...params,
    requestType: 'getGenesisBalances',
  };

  return sendRequest<IGenesysAccountResponse>(requestParams);
};
